import React, { useState, useEffect } from "react";
import { Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api from "@/lib/api";
import { useSite } from "@/context/SiteContext";

const GROUPS = [
  { title: "Company", fields: [["company_name", "Company Name"], ["tagline", "Tagline"], ["address", "Address"]] },
  { title: "Contact", fields: [["phone", "Phone"], ["whatsapp", "WhatsApp Number (with country code, digits only)"], ["email", "Email"]] },
  { title: "Branding", fields: [["logo_url", "Logo URL"], ["favicon_url", "Favicon URL"]] },
  { title: "Social Media", fields: [["facebook", "Facebook"], ["instagram", "Instagram"], ["linkedin", "LinkedIn"], ["twitter", "Twitter/X"], ["youtube", "YouTube"]] },
  { title: "Google Integrations", fields: [["ga4_id", "Google Analytics 4 ID"], ["gtm_id", "Google Tag Manager ID"], ["google_ads_id", "Google Ads ID"], ["search_console", "Search Console Verification"]] },
];

export default function Settings() {
  const { setSettings } = useSite();
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  useEffect(() => { api.get("/settings").then((r) => setForm(r.data || {})).catch(() => {}); }, []);

  const save = async () => {
    setLoading(true);
    try {
      const { data } = await api.put("/admin/settings", form);
      setSettings((s) => ({ ...s, ...data }));
      toast.success("Settings saved");
    } catch (e) { toast.error("Failed to save"); } finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-settings">
      <div className="flex items-center justify-between mb-5">
        <div><h1 className="font-display text-2xl font-bold">Settings</h1><p className="text-slate-400 text-sm mt-1">Control site-wide content and integrations.</p></div>
        <Button data-testid="settings-save" onClick={save} disabled={loading} className="bg-brand-emerald hover:bg-[#C62828] text-white"><Save size={16} className="mr-1" />{loading ? "Saving..." : "Save"}</Button>
      </div>
      <div className="grid gap-5 lg:grid-cols-2">
        {GROUPS.map((g) => (
          <div key={g.title} className="glass rounded-2xl p-5">
            <h3 className="font-display font-semibold mb-4">{g.title}</h3>
            <div className="grid gap-3">
              {g.fields.map(([k, label]) => (
                <div key={k}>
                  <Label className="text-xs">{label}</Label>
                  <Input data-testid={`settings-${k}`} value={form[k] || ""} onChange={upd(k)} className="bg-white/5 border-white/10 mt-1" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
